<template>
  <section>
    <validation-observer ref="faqForm" #default="{ invalid }">
      <b-form @submit.prevent="faqForm" v-if="!loading">
        <b-row>
          <b-col cols="12" xl="9" md="8">
            <b-card>
              <b-row>
                <b-col>
                  <b-form-group label-for="add-faq-active">
                    <b-form-checkbox
                      v-model="faq.active"
                      name="check-active"
                      switch
                      inline
                      :uncheckedValue="0"
                      :value="1"
                    >
                      وضعیت
                    </b-form-checkbox>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12" md="6">
                  <b-form-group label="پرسش" label-for="question" class="w-100">
                    <validation-provider
                      #default="{ errors }"
                      name="question"
                      vid="question"
                      rules="required"
                    >
                      <b-form-input
                        autocomplete="on"
                        id="question"
                        v-model="faq.question"
                        name="question"
                        :state="errors.length > 0 ? false : null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                  <b-form-group label="پاسخ" label-for="answer" class="w-100">
                    <validation-provider
                      #default="{ errors }"
                      name="answer"
                      vid="answer"
                      rules="required"
                    >
                      <b-form-input
                        autocomplete="on"
                        id="answer"
                        v-model="faq.answer"
                        name="answer"
                        :state="errors.length > 0 ? false : null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group
                    label="نوع مدل"
                    label-for="model-type"
                    class="w-100"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="type"
                      vid="type"
                      class="d-flex justify-content-start align-items-center"
                    >
                      <select-box
                        v-model="faq.model.type"
                        label="label"
                        select="val"
                        class="w-100"
                        :lists="[
                          { val: 'semester', label: 'ترم' },
                          { val: 'course', label: 'دوره' },
                          { val: 'session', label: 'جلسه' },
                        ]"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                  <b-form-group
                    label="انتخاب شناسه مدل"
                    label-for="add-semester-events"
                    class="w-100"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="events"
                      vid="events"
                      class="d-flex justify-content-start align-items-center"
                    >
                      <select-box
                        v-model="faq.model.id"
                        label="text"
                        select="id"
                        class="w-100"
                        :url="faq.model.type"
                        searchable
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
          <b-col cols="12" md="4" xl="3" class="invoice-actions mt-md-0 mt-2">
            <b-card>
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                class="mb-75"
                block
                :disabled="invalid"
                type="submit"
              >
                {{ $route.params.id ? "ویرایش" : "ایجاد " }}
              </b-button>

              <b-button
                :to="{ name: 'faqs' }"
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="outline-primary"
                block
              >
                برگشت به لیست پرسش و پاسخ
              </b-button>
            </b-card>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>

    <loader :loading="loading" />
  </section>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import {
  BRow,
  BCol,
  BButton,
  BForm,
  BFormCheckbox,
  BFormGroup,
  BFormInput,
  BInputGroup,
  BInputGroupAppend,
  BCard,
} from "bootstrap-vue";
import { required } from "@validations";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import Ripple from "vue-ripple-directive";
import Loader from "@/@core/components/loader/Loader.vue";
import SelectBox from "@/@core/components/select-box/SelectBox.vue";
export default {
  components: {
    BRow,
    BCol,
    BButton,
    BForm,
    BFormCheckbox,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
    ValidationProvider,
    ValidationObserver,
    Loader,
    SelectBox,
    BCard,
  },
  directives: {
    Ripple,
  },

  data() {
    return {
      faq: {
        question: "",
        answer: "",
        active: 0,
        model: {
          type: "",
          id: "",
        },
      },
      loading: false,
      required,
    };
  },
  created() {
    if (this.$route.params.id) {
      this.getFaq();
    }
  },
  methods: {
    async getFaq() {
      this.loading = true;
      try {
        const { data } = await this.$http.get(
          `/panel/faqs/${this.$route.params.id}`
        );
        await Object.keys(data.data).map((item) => {
          item == "active"
            ? (this.faq[item] = data.data[item] ? 1 : 0)
            : item == "model_type"
            ? (this.faq.model.type = data.data[item])
            : item == "model_id"
            ? (this.faq.model.id = data.data[item])
            : (this.faq[item] = data.data[item]);
        });
      } catch (err) {}
      this.loading = false;
    },
    faqForm() {
      this.$refs.faqForm.validate().then(async (success) => {
        if (success) {
          this.loading = true;
          try {
            if (this.$route.params.id) {
              const { data } = await this.$http.post(
                `/panel/faqs/${this.$route.params.id}`,
                this.faq,
                {
                  params: {
                    _method: "put",
                  },
                }
              );
              await this.getFaq();
            } else {
              const { data } = await this.$http.post(`/panel/faqs`, this.faq);
              this.faq = {
                question: "",
                answer: "",
                active: 0,
                model: {
                  type: "",
                  id: "",
                },
              };
            }
            this.loading = false;
            this.$toast(
              {
                component: ToastificationContent,
                props: {
                  title: `اطلاعات شما با موفقیت ثبت شد.`,
                  icon: "CoffeeIcon",
                  variant: "success",
                },
              },
              { position: "bottom-right" }
            );
          } catch (err) {
            this.loading = false;
          }
        }
      });
    },
  },
};
</script>

<style lang="scss">
.vpd-input-group {
  .vpd-icon-btn {
    margin-bottom: 0;
  }
  .form-control {
    border-radius: 0;
  }
}
</style>
